import { useState, useEffect, useContext, useMemo, useRef } from "react";
import styles from './index.module.scss'
import { Button, Popover, message } from 'antd';
import { IMAGE_TYPE, RESOURCE_TYPE } from '@utils/CONST'
import PSAIModal from '@PSAIComponents/PSAIModal'
import Utils from '@utils/utils'
import { AppContext } from '@utils/AppContext';
import API, { commonApiInvoker } from '@api/api.js';


const DownloadBtn = (props) => {
    const { item } = props
    const { HDCurrentList, setHDCurrentList } = useContext(AppContext)
    const hdCost = useMemo(() => {
        if (item.imageType == IMAGE_TYPE.COMMODITY_VIDEO || item.imageType == IMAGE_TYPE.MODEL_VIDEO || item.imageType == IMAGE_TYPE.IMAGE_TO_VIDEO) return 40
        return 5
    }, [item])

    const haveHD = useMemo(() => {
        return item?.results?.[0]?.hdImage
    }, [item])

    const disabledHD = useMemo(() => {
        return item?.results?.[0]?.hdStatus == 'started' ||
            item?.results?.[0]?.hdStatus == 'pending' ||
            item?.results?.[0]?.hdStatus == 'processing'
    }, [item])

    const commonDownloadFuncEmit = async (e) => {
        e.stopPropagation()
        // const status = Utils.checkFirstDownLoad(() => commonDownloadFunc(e))
        // if (!status) return
        commonDownloadFunc(e)
    }

    const commonDownloadFunc = async (e) => {
        try {
            e.stopPropagation()
            let res = await API.commonDownload({ taskId: item?.taskId })

            if (res?.code != 0) throw new Error(res?.message)
            const image = res.data
            Utils.downUrl(image, item?.imageType)
            message.success('下载成功');
        } catch (err) {
            message.error(err.message)
        }
    }

    const hdDownloadFuncEmit = async (e) => {
        e.stopPropagation()
        // const status = Utils.checkFirstDownLoad(() => hdDownloadFunc(e))
        // if (!status) return
        hdDownloadFunc(e)
    }

    const hdDownloadFunc = async (e) => {
        try {
            e.stopPropagation()
            if (disabledHD) {
                message.warning('正在高清中！')
                return false
            }
            if (!haveHD) {
                PSAIModal.confirm({
                    title: `下载${item?.imageType == IMAGE_TYPE.MODEL_VIDEO ? "高清视频" : "高清图"}将扣除您${hdCost}个虹豆`,
                    content: `该${item?.imageType == IMAGE_TYPE.MODEL_VIDEO ? "视频" : "图片"}生成后进行下载操作无需再次扣点，您确认要下载吗？`,
                    onOk: async () => {
                        await doHDv2()
                    }
                })
            } else {
                const res = await API.hdDownload({ taskId: item?.taskId })

                if (res?.code != 0) throw new Error(res?.message)
                const image = res.data
                Utils.downUrl(image, item?.imageType)
                message.success('下载成功')
            }
        } catch (err) {
            message.error(err.message)
        }
    }

    const doHDv2 = async () => {
        const res = await API.doHDv2({ taskId: item?.taskId, imageType: item?.imageType })
        if (res?.code != 0) throw new Error(res?.message)
        props.fetchProjectDetail()
        setHDCurrentList([...HDCurrentList, item?.taskId])
    }

    const DownloadMenuContent = (
        <div className={styles.DownloadMenu}>
            {
                (item?.imageType != IMAGE_TYPE.MODEL_VIDEO &&
                    item?.imageType != IMAGE_TYPE.IMAGE_TO_VIDEO &&
                    item?.imageType != IMAGE_TYPE.GRASS_PLANT &&
                    (!item?.orgData || haveHD)) && <div className={styles.MenuItem} onClick={(e) => hdDownloadFuncEmit(e)}>
                    <span>高清下载</span>
                    {
                        !haveHD && <div style={{ display: 'flex', alignItems: 'baseline' }}>
                            <img src={require('@assets/images/arcbean3.png')} />
                            <span>{hdCost}</span>
                        </div>
                    }
                </div>
            }

            <div className={styles.MenuItem} onClick={(e) => commonDownloadFuncEmit(e)}>
                <span>普通下载</span>
            </div>
        </div>
    )


    return (
        props.IsEiEdit ? <Button
            className={styles.downloadBtn}
            onClick={(e) => commonDownloadFuncEmit(e)}
            type="primary">下载</Button> :
            <Popover
                placement="top"
                content={DownloadMenuContent}
                arrow={false}
                styles={{ body: { borderRadius: '12px', padding: 0 } }}
            >
                <Button className={styles.downloadBtn} type="primary">下载</Button>
            </Popover>

    )
}

export default DownloadBtn